import React, { Component } from "react";
import { connect } from "react-redux";

class Footer extends Component {

  //render one specific column
  renderColumn = (column) => {
    if (!column) return null;
    //init variables
    const columnTitle = column.columnname;
    //check if column has row data
    const renderAllRows = Array.isArray(column.rows) ? column.rows.map(this.renderRow) : null;

    return (
      <li key={"column" + column.columnorder} aria-label={columnTitle}>
        <h4 aria-level="2">{columnTitle}</h4>
        <ul aria-label="Liste der Themen">
          {renderAllRows}
        </ul>
      </li>
    );
  };

  //render one row
  renderRow = (row) => {
    return (
      <li key={row.rowname} title={row.rowname} className="mb-1">
        <div >
          <a href={row.rowurl} target="_blank" rel="noopener noreferrer">{row.rowname}</a>
        </div>
      </li>
    );
  };

  render() {
    if (!this.props.configStorage.hasFooter()) return null;
    let footer = this.props.mandantStorage.footer || {};
    //render all columns
    let renderAllColumns = Array.isArray(footer.mandantFooterList)
      ? footer.mandantFooterList.map(this.renderColumn)
      : null;

    return (
      <div className="if6_outer if6_sitemap" role="region" title="Fußzeile">
        <h1 className="aria-visible">Fußzeile</h1>
        <div className="if6_inner">
          <ul aria-label="Liste der Bereiche">
            {renderAllColumns}
          </ul>{" "}
          <br className="bterm" />
        </div>
      </div>
    );
  }
}
export default connect(store => {
  return {
    configStorage: store.configStorage,
    mandantStorage: store.mandantStorage
  };
})(Footer);
